// ForgotPassword.jsx
import React, { useState } from "react";
import { IoMailOpenOutline } from "react-icons/io5";
import { useNavigate, useParams } from "react-router-dom";
import { forgotPassword } from "../../services/LoginAuthService/LoginAuthService";
import "../../assets/styles/AdminLoginStyles/AdminLogin.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [role, setRole] = useState("superadmin");
  const [errors, setErrors] = useState({ email: "" });
  const [showEmailField, setShowEmailField] = useState(false);
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const navigate = useNavigate();

  const params = useParams();
  const token = params.token; // Get token from path parameter

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    let validationErrors = {};

    if (!email.trim()) {
      validationErrors.email = "This field is required";
    } else if (!validateEmail(email)) {
      validationErrors.email = "Invalid email format";
    }

    setErrors(validationErrors);
    if (Object.keys(validationErrors).length !== 0) return;

    setLoading(true);
    try {
      const response = await forgotPassword(role, email);
      // console.log(response.error);
      if (response?.token) {
        localStorage.setItem("token", response.token);
      }

      // Instead of setting a success message, show a toast notification
      toast.success(
        "Password reset link has been sent to your email! Check your email and click the link to reset your password"
      );
    } catch (error) {
      if (error.a_email) {
        setErrors({ email: error.a_email[0] });
      } else {
        toast.error(
          error.error || "Failed to send reset link. Please try again."
        );
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-gray-900 background w-full h-[100vh] flex items-center">
      <div className="flex justify-center mx-auto w-full h-[70vh] rounded-xl">
        <div className="z-10 relative flex flex-col justify-center w-full md:w-3/5 p-5 md:px-20 rounded-e-2xl">
          <div className="absolute -z-10 inset-0 border-2 border-red-600 rounded-xl backdrop-blur-sm bg-red-500/50"></div>
          <div className="absolute -top-10 left-1/2 transform -translate-x-1/2 flex justify-center">
            <img
              src={require("../../assets/images/commonImages/ZeroMiddleMan Logo 3.png")}
              alt=""
              className="bg-white px-4 rounded-2xl w-32 md:w-48"
            />
          </div>
          <div className="mb-12">
            <div className="hidden absolute md:flex gap-2 flex-col right-5 md:right-10">
              <select
                className="bg-transparent outline-none border-2 border-white text-white px-2 py-1 rounded-md"
                value={role}
                onChange={(e) => setRole(e.target.value)}
              >
                <option className="text-black" value="superadmin">
                  Super Admin
                </option>
                <option className="text-black" value="admin">
                  Admin
                </option>
                <option className="text-black" value="employee">
                  Employee
                </option>
              </select>
            </div>
            <div className="flex justify-center">
              <h1 className="text-white text-sm md:text-lg w-1/2 flex justify-center items-center font-light text-center">
                After entering your email address, you will receive a link to
                your email to reset your password.
              </h1>
            </div>
          </div>
          <div className="flex flex-col gap-5">
            <div className="flex flex-col">
              {!showEmailField && (
                <div
                  className="px-2 flex items-center gap-2 cursor-pointer text-white py-2 outline-none border-b border-white bg-transparent"
                  onClick={() => setShowEmailField(true)}
                >
                  <IoMailOpenOutline className="text-2xl text-semibold" />
                  <label className="font-semibold text-lg md:text-xl">
                    Email
                  </label>
                </div>
              )}
              {showEmailField && (
                <input
                  className="px-5 py-2 text-white placeholder-white placeholder:text-lg placeholder:font-semibold outline-none border-b bg-transparent w-full"
                  type="text"
                  placeholder="Enter your Email Address"
                  value={email}
                  name="email"
                  autoFocus
                  onChange={(e) => setEmail(e.target.value)}
                />
              )}
              {errors.email && (
                <p className="text-white text-sm">{errors.email}</p>
              )}
            </div>
          </div>

          <div className="flex justify-center mt-5">
            <button
              className="px-10 py-2 bg-white text-[#ff0000] hover:bg-[#d93030] hover:text-white rounded-md flex items-center justify-center"
              onClick={handleSubmit}
              disabled={loading} // Disable button when loading
            >
              {loading ? "Generating Link..." : "Reset Password"}
            </button>
          </div>

          {errors.api && (
            <div className="text-white text-center mb-4">{errors.api}</div>
          )}

          {/* ToastContainer renders the popup notifications */}
          <ToastContainer position="top-center" autoClose={5000} />
        </div>
      </div>
    </div>
  );
};
export default ForgotPassword;
